/**
 * Auto-advances product gallery slideshows and keeps controls in sync.
 * Works with or without the full Horizon slideshow.js module.
 */
function initProductGalleryAutoplay() {
  document.querySelectorAll('media-gallery[data-autoplay-speed] slideshow-component').forEach((slideshow) => {
    if (slideshow.dataset.autoplayBound === 'true') return;

    const gallery = slideshow.closest('media-gallery');
    const slides = [...slideshow.querySelectorAll('slideshow-slide')];
    if (slides.length <= 1) return;

    slideshow.dataset.autoplayBound = 'true';

    const seconds = parseInt(gallery?.dataset.autoplaySpeed, 10);
    const intervalMs = (Number.isNaN(seconds) ? 4 : seconds) * 1000;

    const getActiveIndex = () => {
      const index = slides.findIndex((slide) => slide.getAttribute('aria-hidden') !== 'true');
      return index === -1 ? 0 : index;
    };

    const syncControls = (index) => {
      slideshow.querySelectorAll('.slideshow-controls__thumbnail').forEach((button, i) => {
        button.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });

      slideshow.querySelectorAll('.slideshow-controls__dots button').forEach((button, i) => {
        button.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
    };

    const goToSlide = (index) => {
      const selectButton =
        slideshow.querySelector(`[on\\:click="/select/${index}"]`) ||
        slideshow.querySelector(`.slideshow-controls__thumbnail:nth-child(${index + 1})`) ||
        slideshow.querySelector(`.slideshow-controls__dots li:nth-child(${index + 1}) button`);

      if (selectButton) {
        selectButton.click();
        return;
      }

      slides.forEach((slide, i) => {
        const isActive = i === index;
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');

        if (isActive) {
          slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      });

      syncControls(index);
    };

    let timer;

    const advance = () => {
      if (slideshow.matches(':hover') || document.hidden || slideshow.hasAttribute('paused')) return;

      const nextIndex = (getActiveIndex() + 1) % slides.length;
      goToSlide(nextIndex);
    };

    const start = () => {
      clearInterval(timer);
      timer = setInterval(advance, intervalMs);
    };

    const stop = () => {
      clearInterval(timer);
      timer = undefined;
    };

    slideshow.addEventListener('mouseenter', stop);
    slideshow.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stop();
      else start();
    });

    slideshow.addEventListener('click', (event) => {
      if (event.target.closest('.slideshow-control, .slideshow-controls__thumbnail, .slideshow-controls__dots button')) {
        stop();
        setTimeout(start, intervalMs);
      }
    });

    start();
  });
}

initProductGalleryAutoplay();

document.addEventListener('shopify:section:load', initProductGalleryAutoplay);